import { keyBy } from 'lodash';

import {
  calculateSelectionRate,
  ToggleFilterCriteria,
} from 'components/ToggleListModal/toggleCriteria/earnedSearchesCriteria';
import { ItemsIndexKeys } from 'components/ToggleListModal/types';
import { EARNED_SEARCHES_FILTERS_OPERATORS } from 'constants/constants';
import {
  CONTENT_TYPE_VALUES_LENGTH,
  contentTypeFilterLocalSource,
  JOB_POSTINGS,
  MARKET_RESEARCH_REPORTS,
} from 'pages/EarnedSearch/FiltersLocalSources/contentType';
import FiltersActions from 'pages/EarnedSearch/state/actions/filtersActions';
import {
  ActionType,
  Filter,
  TransformedFilter,
} from 'pages/EarnedSearch/state/types/filters';

export function setLanguageFilter(language: Filter): ActionType {
  return {
    payload: { language },
    type: FiltersActions.SET_LANGUAGE_FILTER,
  };
}

export function setLocationFilter(location: Filter): ActionType {
  return {
    payload: { location },
    type: FiltersActions.SET_LOCATION_FILTER,
  };
}

export function setRegionFilter(region: Filter): ActionType {
  return {
    payload: { region },
    type: FiltersActions.SET_REGION_FILTER,
  };
}

export function setContentTypeFilter(contentType: Filter): ActionType {
  return {
    payload: { contentType },
    type: FiltersActions.SET_CONTENT_TYPE_FILTER,
  };
}

export function udpateContentTypeFilter(
  isQualityFilterSelected: boolean,
  contentType: Filter,
): ActionType {
  if (!isQualityFilterSelected) {
    return {
      type: FiltersActions.RESET_CONTENT_TYPE_FILTER,
    };
  }

  let selectedValues = contentType.values.filter(
    filter =>
      filter.value !== JOB_POSTINGS && filter.value !== MARKET_RESEARCH_REPORTS,
  );
  let selectedValuesCount = selectedValues.length;
  let unselectedValues = [
    { [ItemsIndexKeys.VALUE]: JOB_POSTINGS },
    { [ItemsIndexKeys.VALUE]: MARKET_RESEARCH_REPORTS },
  ];
  if (contentType.operator === EARNED_SEARCHES_FILTERS_OPERATORS.not) {
    const unselectedValuesMap = keyBy(
      unselectedValues.concat(selectedValues),
      ItemsIndexKeys.VALUE,
    );
    unselectedValues = Object.values(unselectedValuesMap);
    const unselectedValuesKeys = Object.keys(unselectedValuesMap);
    selectedValues = contentTypeFilterLocalSource().filter(
      contentType => !unselectedValuesKeys.includes(contentType.value),
    );
    selectedValuesCount = selectedValues.length;
  }

  const selectionRate = calculateSelectionRate(
    selectedValuesCount,
    CONTENT_TYPE_VALUES_LENGTH,
  );
  const newContentTypeFilterData = ToggleFilterCriteria.standard(
    selectionRate,
    selectedValues,
    unselectedValues,
  );
  return {
    type: FiltersActions.SET_CONTENT_TYPE_FILTER,
    payload: {
      contentType: newContentTypeFilterData,
    },
  };
}

export function setMediaTypeFilter(mediaType: Filter): ActionType {
  return {
    payload: { mediaType },
    type: FiltersActions.SET_MEDIA_TYPE_FILTER,
  };
}

export function resetFilters(): ActionType {
  return {
    type: FiltersActions.RESET_FILTERS,
  };
}

export function resetLanguageFilter(): ActionType {
  return {
    type: FiltersActions.RESET_LANGUAGE_FILTER,
  };
}

export function resetLocationFilter(): ActionType {
  return {
    type: FiltersActions.RESET_LOCATION_FILTER,
  };
}

export function resetRegionFilter(): ActionType {
  return {
    type: FiltersActions.RESET_REGION_FILTER,
  };
}

export function resetContentTypeFilter(): ActionType {
  return {
    type: FiltersActions.RESET_CONTENT_TYPE_FILTER,
  };
}

export function resetMediaTypeFilter(): ActionType {
  return {
    type: FiltersActions.RESET_MEDIA_TYPE_FILTER,
  };
}

export function setFilters(filtersData): ActionType {
  const filters = Object.keys(filtersData).reduce((acc, filterKey) => {
    if (filtersData[filterKey].values.length > 0) {
      const filterValues = filtersData[filterKey].values.map(
        (filterValueData: any) => ({
          [ItemsIndexKeys.VALUE]: filterValueData,
        }),
      );
      acc[filterKey] = {
        operator: filtersData[filterKey].operator,
        values: filterValues,
      };
    }
    return acc;
  }, {});
  return {
    type: FiltersActions.SET_FILTERS,
    payload: filters,
  };
}

export function setModalLoadingStatus(
  filterType: string,
  status: boolean,
): ActionType {
  return {
    type: FiltersActions.SET_MODAL_LOADING_STATUS,
    payload: { filterType, status },
  };
}

export function setFilterValues(
  filterType: string,
  filterValues: TransformedFilter[],
): ActionType {
  return {
    type: FiltersActions.SET_FILTER_VALUES,
    payload: { filterType, filterValues },
  };
}

export function resetModalError(): ActionType {
  return {
    type: FiltersActions.RESET_MODAL_ERROR,
  };
}

export function setModalError(error: string): ActionType {
  return {
    type: FiltersActions.SET_MODAL_ERROR,
    payload: { error },
  };
}

export function setLanguageV2Filters(filters): ActionType {
  return {
    type: FiltersActions.SET_LANGUAGE_V2_FILTER,
    payload: filters,
  };
}

export function setLocationV2Filters(filters): ActionType {
  return {
    type: FiltersActions.SET_LOCATION_V2_FILTER,
    payload: filters,
  };
}
